// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const MonitoringOff = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M33.29,20.82C33.29,28.93,20,35.5,20,35.5S6.71,28.93,6.71,20.82V6.12A1.61,1.61,0,0,1,8.32,4.5H31.68a1.63,1.63,0,0,1,1.61,1.62Z" />
            <Path d="M20,36a.5.5,0,0,1-.22-.05c-.55-.27-13.56-6.81-13.56-15.13V6.12A2.12,2.12,0,0,1,8.32,4H31.68a2.12,2.12,0,0,1,2.11,2.12V20.82c0,8.33-13,14.86-13.56,15.13A.5.5,0,0,1,20,36ZM8.32,5A1.12,1.12,0,0,0,7.21,6.12V20.82C7.21,28,18.28,34,20,34.94c1.72-.9,12.79-7,12.79-14.12V6.12A1.13,1.13,0,0,0,31.68,5Z" />
            <Path d="M27.07,18H12.93a.5.5,0,0,1,0-1H27.07a.5.5,0,0,1,0,1Z" fill="#fff" />
        </G>
    );
};

export default MonitoringOff;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/monitoring-off/index.js